import { createAppShell } from './app/shell';
import { BrowserRouter } from './app/router';
import './styles/main.css';

const root = document.querySelector<HTMLDivElement>('#app');

if (!root) {
  throw new Error('V2 application root was not found.');
}

const router = new BrowserRouter(window);
const shell = createAppShell(router);
root.replaceChildren(shell);
router.start();
